import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIMask from './UI.Mask';
import { Icon } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

    /** 是否隐藏 */
    isHide: boolean;

    /** 标题 */
    title: string | JSX.Element;

    /** 宽 */
    width: number;
}

export class UIContainerStatic {

    /** 是否初始化完成 */
    public isInit: boolean = false;

    /** 是否开始初始化 */
    public isOpen: boolean = false;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIContainer extends UIBasic<IProps, ModulesState, UIContainerStatic> {

    state = new UIContainerStatic();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isInit: true });
        }, 200);
        setTimeout(() => {
            this.setState({ isOpen: true });
        }, 1);
    }

    componentDidUpdate() {
        if (this.props.isHide) {
            setTimeout(() => {
                MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, null);
            }, 200);
        }
    }

    render() {
        return (
            <div>
                <UIMask />
                <div className={css.container} style={this.style}>
                    <div className={css.title} >
                        <span>{this.props.title}</span>
                        <Icon onClick={MyStore.instance.getDispatchProxy(reducers.rightPopUps.ActionTypes.removeHide) as any} className={css.cha1} type="cha1" />
                    </div>
                    <div className={css.body} style={{ display: this.state.isOpen ? undefined : 'none' }} >
                        {this.state.isInit && !this.props.isHide && this.props.children}
                    </div>
                </div>
            </div>
        );
    }

    private get style(): any {
        const res = {
            width: this.props.width || 450,
            right: 0,
        };

        // 初始化完成 和 没有被隐藏
        if (!this.props.isHide && this.state.isOpen) {
            res.right = 0;
        } else {
            res.right = -this.props.width || -450;
        }

        return res;
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/RightPopUps/UI.Container.tsx